module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Página em construção",
      "icone": "fa fa-cog fa-spin",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "A página que você está tentando acessar não foi construída ainda.\n\t\tVolte mais tarde, por favor."
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64d985ec","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/construcao/index.vue
// module id = 5j8y
// module chunks = 5